export default "__VITE_ASSET__BjjZ54bJ__"